import type React from 'react';
import type { PropsWithChildren } from 'react';

import type { WithDataTestid } from '@vlabs/uikit/types';

import st from './Subsection.module.sass';
import type { HeaderProps } from '../header/Header';

interface SubsectionProps extends PropsWithChildren, WithDataTestid {
  title?: string;
  headers?: React.ReactElement<HeaderProps> | React.ReactElement<HeaderProps>[];
}

function Subsection({
  title = undefined,
  headers = undefined,
  children = undefined,
  'data-testid': dataTestId = undefined,
}: SubsectionProps): React.JSX.Element {
  return (
    <div
      className={st.Subsection}
      data-testid={dataTestId}
    >
      <div className={st.Heading}>
        <span className={st.HeadingText}>
          {title}
        </span>
        <div className={st.HeaderList}>
          {headers}
        </div>
      </div>
      <div className={st.List}>
        {children}
      </div>
    </div>
  );
}

export { Subsection };
